import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import appTheme from './theme/theme';
import { FeedbackProvider } from './components/ui';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import FastDelivery from './pages/FastDelivery';
import Enquiries from './pages/Enquiries';
import Banners from './pages/Banners';
import ProductsV2 from './pages/ProductsV2';
import CategoriesV2 from './pages/CategoriesV2';
import CouponsV2 from './pages/CouponsV2';
import InventoryV2 from './pages/InventoryV2';
import Users from './pages/Users';
import Stores from './pages/Stores';
import Analytics from './pages/Analytics';
import HomepageCustomizer from './pages/HomepageCustomizer';
import BankOffers from './pages/BankOffers';
import CartAddons from './pages/CartAddons';

const ProtectedLayout = ({ children }) => (
  <ProtectedRoute>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <FeedbackProvider>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<ProtectedLayout><Dashboard /></ProtectedLayout>} />
              <Route path="/orders" element={<ProtectedLayout><Orders /></ProtectedLayout>} />
              <Route path="/fast-delivery" element={<ProtectedLayout><FastDelivery /></ProtectedLayout>} />
              <Route path="/enquiries" element={<ProtectedLayout><Enquiries /></ProtectedLayout>} />
              <Route path="/banners" element={<ProtectedLayout><Banners /></ProtectedLayout>} />
              <Route path="/homepage-layout" element={<ProtectedLayout><HomepageCustomizer /></ProtectedLayout>} />
              <Route path="/bank-offers" element={<ProtectedLayout><BankOffers /></ProtectedLayout>} />
              <Route path="/cart-addons" element={<ProtectedLayout><CartAddons /></ProtectedLayout>} />
              <Route path="/products" element={<ProtectedLayout><ProductsV2 /></ProtectedLayout>} />
              <Route path="/categories" element={<ProtectedLayout><CategoriesV2 /></ProtectedLayout>} />
              <Route path="/coupons" element={<ProtectedLayout><CouponsV2 /></ProtectedLayout>} />
              <Route path="/inventory" element={<ProtectedLayout><InventoryV2 /></ProtectedLayout>} />
              <Route path="/users" element={<ProtectedLayout><Users /></ProtectedLayout>} />
              <Route path="/stores" element={<ProtectedLayout><Stores /></ProtectedLayout>} />
              <Route path="/analytics" element={<ProtectedLayout><Analytics /></ProtectedLayout>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
        </AuthProvider>
      </FeedbackProvider>
    </ThemeProvider>
  );
}

export default App;
